import React from 'react'
import CalendarDate from '../calendar/CalendarDate';
import Nav from '../Nav';

export default function Homepage() {


  return (
    <div className='container'>
      <Nav/>
   <CalendarDate/>     

        
    </div>
  )
}
